jQuery(document).ready(function ($) {
    $('.stocked').on('click', function () {
        $('#modal-simple').addClass('show');
    });
    $("#modal-simple .close").on('click',function(){
        $('#modal-simple').removeClass('show');
    });

    var $defaultActive = $('.MuiGrid-ul li.active');
    if ($defaultActive.length) {
        updateSelectedFabric($defaultActive,"Fabric shown in image - ");
    }

    $(document).on("click", ".MuiGrid-ul li", function () {
        var $this = $(this);

        $('.MuiGrid-ul li').removeClass("active");
        $this.addClass("active");

        updateSelectedFabric($this,"Fabric selected by you - ");

        $this.find('.radio__check').prop('checked', true);
    });
    
    function handleImageHoverOrTouch(event, target) {
        var $target = $(target);
        var selectedAlt = $target.find(".MuiGrid__img--img").attr("alt");

        var matchingMainImage = $(".product-medias__main img").filter(function () {
            return $(this).attr("alt") === selectedAlt;
        });

        if (matchingMainImage.length) {
            var mainImgSrc = matchingMainImage.attr("src") || matchingMainImage.attr("data-src");
            $target.find(".MuiGridList__hoverWrapper img").attr("src", mainImgSrc);
        }

        var pageY = event.pageY;
        var viewportHeight = window.innerHeight;
        var elementTop = $target.offset().top;
        var hoverBoxHeight = $target.find(".MuiGridList__hoverWrapper").height();

        var spaceBelow = pageY - (elementTop - $(window).scrollTop());

        if (spaceBelow < hoverBoxHeight + 50) {
            $target.find(".MuiGridList__hoverWrapper").css('top', "-220px");
        } else {
            $target.find(".MuiGridList__hoverWrapper").css('top', "180px");
        }
    }

    $(document).on("mouseenter", ".MuiGrid-ul li", function (event) {
        if (window.innerWidth > 768) {
            handleImageHoverOrTouch(event, this);
        }
    });

    $(document).on("touchstart", ".MuiGrid-ul li", function (event) {
        if (window.innerWidth <= 768) {
            handleImageHoverOrTouch(event, this);
        }
    });

    function updateSelectedFabric($element,text) {
        var selectedImg = $element.find('.MuiGrid__img--img').attr('src') || '';
        var selectedTitle = $element.find('.MuiTypography-body1').text() || '';

        var selectedVal = $element.find('.radio__check').val() || '';
        $(".selected_fabric").val(selectedVal);
        $(".fabric-line").text(text);
        $(".fabric-line-title").text(selectedTitle);

        $('.selected-fabric-img img').attr('src', selectedImg);
        //$('.selected-fabric-tile .selected-fabric-title').text(selectedTitle);
        $('.selected-fabric-tile').removeClass("d-none");
    }  
});